import { Language } from "interfaces/locale";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useLanguage = () => {
  const { i18n } = useTranslation();
  const language = useMemo(() => i18n.language.slice(0, 2), [i18n.language]) as Language;

  return { language };
};

export default useLanguage;
